var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M15.6,15.6l-.1-2.73h3l-.1,2.73L18,21.87H16Z","key":1}),React.createElement("circle",{"cx":"17","cy":"25.37","r":"1.5","key":2}),React.createElement("path",{"d":"M17,4V5L32,28.85A.1.1,0,0,1,32,29s0,0,0,0H2.06a0,0,0,0,1,0,0,.12.12,0,0,1,0-.15L17,5h0V4m0,0a1,1,0,0,0-.84.45L1.19,28.29A1.09,1.09,0,0,0,2.06,30H31.94a1.09,1.09,0,0,0,.9-1.67l-15-23.84A1,1,0,0,0,17,4Z","key":3})]);
}

Warning.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Warning;

Warning.default = Warning;
